module.exports = __webpack_public_path__ + "static/media/building.88209aa4.svg";